import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Download, RefreshCw, Mail, Users } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLeads = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(0);

  const fetchLeads = async () => {
    setLoading(true);
    try {
      const [leadsRes, countRes] = await Promise.all([
        axios.get(`${API}/leads`),
        axios.get(`${API}/leads/count`)
      ]);
      setLeads(leadsRes.data);
      setCount(countRes.data.count);
    } catch (error) {
      console.error('Failed to fetch leads:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeads();
  }, []);

  const handleExport = () => {
    window.open(`${API}/leads/export`, '_blank');
  };

  const formatDate = (timestamp) => {
    return new Date(timestamp).toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div style={{ minHeight: '100vh', background: '#000', color: '#fff', padding: '40px 20px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: '40px' }}>
          <h1 style={{ fontSize: '36px', fontWeight: 'bold', marginBottom: '8px' }}>
            Email Leads Dashboard
          </h1>
          <p style={{ color: '#999', fontSize: '16px' }}>
            Forest Guardian Watch - Kickstarter Pre-Launch
          </p>
        </div>

        {/* Stats */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '40px' }}>
          <div style={{ background: '#111', border: '1px solid #333', padding: '24px', borderRadius: '8px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
              <Users size={24} color="#00FFD1" />
              <span style={{ color: '#999', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                Total Leads
              </span>
            </div>
            <div style={{ fontSize: '48px', fontWeight: 'bold', color: '#00FFD1' }}>
              {count}
            </div>
          </div>
        </div>

        {/* Actions */}
        <div style={{ display: 'flex', gap: '12px', marginBottom: '32px', flexWrap: 'wrap' }}>
          <Button 
            onClick={fetchLeads} 
            disabled={loading}
            style={{ background: '#00FFD1', color: '#000', display: 'flex', alignItems: 'center', gap: '8px' }}
          >
            <RefreshCw size={18} />
            Refresh
          </Button>
          <Button 
            onClick={handleExport}
            style={{ background: 'rgba(255,255,255,0.1)', color: '#fff', display: 'flex', alignItems: 'center', gap: '8px' }}
          >
            <Download size={18} />
            Export to CSV
          </Button>
        </div>

        {/* Leads Table */}
        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px', color: '#999' }}>
            Loading leads...
          </div>
        ) : leads.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px', color: '#999' }}>
            <Mail size={48} style={{ opacity: 0.3, marginBottom: '16px' }} />
            <p>No leads collected yet</p>
          </div>
        ) : (
          <div style={{ background: '#111', border: '1px solid #333', borderRadius: '8px', overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#1a1a1a', borderBottom: '1px solid #333' }}>
                  <th style={{ padding: '16px', textAlign: 'left', color: '#00FFD1', fontSize: '14px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    Name
                  </th>
                  <th style={{ padding: '16px', textAlign: 'left', color: '#00FFD1', fontSize: '14px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    Email
                  </th>
                  <th style={{ padding: '16px', textAlign: 'left', color: '#00FFD1', fontSize: '14px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    Timestamp
                  </th>
                </tr>
              </thead>
              <tbody>
                {leads.map((lead, index) => (
                  <tr 
                    key={lead.id} 
                    style={{ 
                      borderBottom: index < leads.length - 1 ? '1px solid #222' : 'none',
                      transition: 'background 0.2s'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#1a1a1a'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                  >
                    <td style={{ padding: '16px', fontSize: '15px' }}>{lead.name}</td>
                    <td style={{ padding: '16px', fontSize: '15px', color: '#ccc' }}>{lead.email}</td>
                    <td style={{ padding: '16px', fontSize: '14px', color: '#999' }}>
                      {formatDate(lead.timestamp)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminLeads;
